type IconProps = { className?: string };

export function OvhBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#123F6D" />
      <path
        fill="#fff"
        d="M5.5 16.5V7.5h3.2c2.2 0 3.5 1.1 3.5 2.9 0 1.2-.6 2.1-1.6 2.5l2.1 3.6h-2l-1.9-3.3H7.3v3.3H5.5zm1.8-5h1.3c1 0 1.6-.4 1.6-1.2 0-.8-.6-1.2-1.6-1.2H7.3v2.4z"
      />
    </svg>
  );
}
